import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import Application from 'bundles/widget-simulator/components/Application';
import NotFound from 'bundles/widget-simulator/components/NotFound';
import RootPage from 'bundles/widget-simulator/components/RootPage';

const makeRoutes = (root: $TSFixMe) => (
  <Route path={root} component={Application}>
    <IndexRoute component={RootPage} />
    <Route path="*" component={NotFound} />
  </Route>
);

const routes = (
  <Route>
    {makeRoutes('/plugin-simulator')}
    {makeRoutes('/prod/plugin-simulator')}
  </Route>
);

export default routes;
